import { useQuery as useApolloQuery } from '@apollo/client';
import { useRouter } from 'next/router';
import { cmsDataService } from '~/services/cms-data-service';

export const useQuery = (query, { ...rest }) => {
  const router = useRouter();

  const { variables, ...otherParams } = rest;
  const siteHandle = cmsDataService.getSiteHandle(router.locale);

  const data = useApolloQuery(query, {
    ...otherParams,
    variables: {
      ...rest.variables,
      siteHandle,
    },
  });

  return { ...data };
};
